import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useModuleSettings } from "../moduleSettingsContext/ModuleSettingsContext";
import { getUserPermissions, hasPermissionForModule, isAdmin } from "../../common/LocalStorageService";

const AppSidebar = () => {
  const { resetSettings } = useModuleSettings();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (window.feather) {
      window.feather.replace();
    }
  }, [location.pathname]);

  const handleNavigation = () => {
    resetSettings();
  };

  const menuItems = [
    {
      items: [
        {
          route: "/dashboard",
          icon: "airplay",
          text: "Dashboards",
          name: "dashboard"
        },
        { route: "/users", icon: "users", text: "Manage Family", name: "user" },
        { route: "/familymember", icon: "user-check", text: "Manage Family Members", name: "Manage Family Members" },
        { route: "/category", icon: "grid", text: "Categories", name: "  categories" },
        { route: "/subcategory", icon: "layers", text: "Sub Categories", name: "manage categories" },
        { route: "/discount", icon: "percent", text: "Manage Discount Codes", name: "manage discount vodes" },
        { route: "/task", icon: "check-square", text: "Manage Tasks", name: "Manage Tasks" },
        { route: "/subscription", icon: "credit-card", text: "Subscription Plans", name: "subscription plans" },
        { route: "/earning", icon: "dollar-sign", text: "Earnings", name: "earnings" },
        { route: "/contactus", icon: "mail", text: "Contact Us Inquiry", name: "contactus" },
        { route: "/notification", icon: "bell", text: "Notification", name: "Notification" },
        {
          route: "#sidebarCrm",
          icon: "file-text",
          text: "Page Content",
          name: "cms",
          subItems: [
            { route: "/about", text: "About Us" },
            { route: "privacy-policy", text: "Privacy Policy" },
            { route: "terms-condition", text: "Term & Condition" },
            { route: "/faq", text: "FAQ" },
            { route: "contact-us", text: "Contact Us" },
          ],
          },
            // // {
          //   route: "#sidebarReview",
          //   icon: "star",
          //   text: "Review",
          //   name: "review",
          //   subItems: [
          //     { route: "/review/course", text: "Course Review" },
          //   ],
          // },
          // { route: "/corporate-profile", icon: "briefcase", text: "Corporate Profile", name: "corporate profile" },
          // { route: "/subadmin", icon: "shield", text: "Sub-Admin", name: "subadmin" },
          // { route: "/language", icon: "globe", text: "Language", name: "language" },
          // { route: "/community-forum", icon: "message-square", text: "Community Forum", name: "community forum" },
          // { route: "/blog", icon: "edit", text: "Blogs", name: "blog" },
          // { route: "/animated-video", icon: "film", text: "Animated Video", name: "animated video" },
          // { route: "/complaint-feedback", icon: "mail", text: "Complaint Feedback", name: "complaint feedback" },
          // { route: "/chat", icon: "message-circle", text: "Chat", name: "chat" },
          // {
          //   route: '#sidebarReport',
          //   icon: 'file-text',
          //   text: 'Report',
          //   name: 'report',
          //   subItems: [
          //     { route: '/training-report', text: "Training Progress and Completion" },
          //     { route: '/instructor-report', text: "Instructor Performance" },
          //     { route: '/user-report', text: "User Activity and Engagement" },
          //     { route: '/course-earnings', text: "Financial" },
          //     { route: '/certification-report', text: "Certification Tracking" },
          //   ]
          // }
        ],
      },
    ];

    const PublicRoutes = ["complaint feedback", "notifications"];

    return (
      <div className="left-side-menu" style={{ overflowY: "auto" }}>
        <div className="h-100">
          <div className="user-box text-center">
            {/* User avatar and dropdown */}
          </div>
          <div id="sidebar-menu">
            <ul id="side-menu">
              {menuItems.map((section, sectionIndex) => (
                <React.Fragment key={sectionIndex}>
                  {section.items.map((item, itemIndex) => {
                    const hasPermission = item.name === "dashboard" || ((hasPermissionForModule(item.name) && getUserPermissions(item.name).is_view) || isAdmin()) || PublicRoutes.includes(item.name);
                    if (!hasPermission) return null;

                    const isActive = location.pathname === item.route;
                    const isSubOpen = item?.subItems && item?.subItems?.some((val) => location.pathname === val.route);
                    
                    return (
                      <li key={itemIndex} className={isActive || isSubOpen ? "menuitem-active" : ""}>
                        <Link
                          to={item.route}
                          data-bs-toggle={item.subItems ? "collapse" : undefined}
                          onClick={() => {
                            handleNavigation();
                            // Re-initialize icons after navigation
                            setTimeout(() => {
                              if (window.feather) {
                                window.feather.replace();
                              }
                            }, 0);
                          }}
                        >
                          <i data-feather={item.icon} />
                          {item.badge && (
                            <span className={`badge ${item.badge.class}`}>{item.badge.text}</span>
                          )}
                          <span> {item.text} </span>
                          {item.subItems && !item.badge && <span className="menu-arrow" />}
                        </Link>
                        {item.subItems && (
                          <div className="collapse" id={item.route.substring(1)}>
                            <ul className="nav-second-level">
                              {item.subItems.map((subItem, subItemIndex) => {
                                const isActive = location.pathname === subItem.route;
                                return (
                                  <li key={subItemIndex} className={isActive ? "menuitem-active" : ""}>
                                    <Link to={subItem.route}>{subItem.text}</Link>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        )}
                      </li>
                    );
                  })}
                </React.Fragment>
              ))}
            </ul>
          </div>
        </div>
      </div>
    );
  };

  export default AppSidebar;